import type { SxProps, Theme } from '@mui/material';

export const getContainerSx = (theme: Theme, sx?: SxProps<Theme>) => ({
  gap: 10,
  backdropFilter: 'blur(28px)',
  background: theme.palette.black_40,
  borderRadius: 12,
  p: 10,
  ...sx,
});